export default __webpack_public_path__ + "static/media/contact-1.3fac939a.png";